import PropTypes from 'prop-types'
import React from 'react'
import ListeProducteurs from './ListeProducteurs'

const listeProducteursContainer = ({ data, loading, page }) => {
  const nbParPage = 50

  return (
    <ListeProducteurs
      resultatsRecherche={data}
      loading={loading}
      nbProdParPage={nbParPage}
      page={page}
    />
  )
}

export default listeProducteursContainer

listeProducteursContainer.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}
